// Authentication Pages

export default [{
        params: {
            path: "/home",
            name: "Home",
        },
        defaultComponentPath: "Pages/dashboard/Home",
        navs: true,
    },
    {
        params: {
            path: "/brand",
            name: "brand",
            meta : {
              permission: "List brand",
            },
        },
        defaultComponentPath: "Pages/brand",
        navs: true,
    },
    // config
        //news
    {
      params: {
          path: "/manage_page/Page_manager",
          name: "manage_page/Page_manager",
          meta : {
            permission: "New page",
          },
      },
      defaultComponentPath: "Pages/config/news",
      navs: true,
  },
  {
    params: {
        path: "/manage_page/Page_manager/add_new_post_config",
        name: "add_new_post_config",
    },
    defaultComponentPath: "Pages/config/configNew/add_new_post_config",
    navs: true,
},
{
  params: {
      path: "/manage_page/Page_manager/edit_new_post_config/:id",
      name: "edit_new_post_config",
  },
  defaultComponentPath: "Pages/config/configNew/edit_new_post_config",
  navs: true,
},
  // home
  {
    params: {
      path: "/manage_page/Home",
      name: "manage_page/Home",
      meta : {
        permission: "Home page",
      },
    },
    defaultComponentPath: "Pages/Home",
    navs: true,
  },
  // blanco
  {
    params: {
      path: "/manage_page/Manage_blanco",
      name: "manage_page/Manage_blanco",
      meta : {
        permission: "Blanco",
      },
    },
    defaultComponentPath: "Pages/config/configBlanco/blanco",
    navs: true,
  },
    // bosch
    {
      params: {
        path: "/manage_page/Manage_bosch",
        name: "manage_page/Manage_bosch",
        meta : {
          permission: "Bosch",
        },
      },
      defaultComponentPath: "Pages/config/configBosch/bosch",
      navs: true,
    },
      // blum
  // {
  //   params: {
  //     path: "/manage_page/Manage_blum",
  //     name: "manage_page/Manage_blum",
  //   },
  //   defaultComponentPath: "Pages/config/configBlum/blum",
  //   navs: true,
  // },
    // wmf
    {
      params: {
        path: "/manage_page/Manage_wmf",
        name: "manage_page/Manage_wmf",
        meta : {
          permission: "Wmf",
        },
      },
      defaultComponentPath: "Pages/config/configWmf/wmf",
      navs: true,
    },
      // finish
  {
    params: {
      path: "/manage_page/Manage_finish",
      name: "manage_page/Manage_finish",
      meta : {
        permission: "Finish",
      },
    },
    defaultComponentPath: "Pages/config/configFinish/finish",
    navs: true,
  },
    /*renew*/
    {
        params: {
            path: "/manage_page/trade_in_sale",
            name: "manage_page/Config_renew",
            meta : {
              permission: "Trade in sale page",
            },
        },
        defaultComponentPath: "Pages/config/config_renew",
        navs: true,
    },
    {
        params: {
            path: "/manage_page/Config_advise",
            name: "manage_page/Config_advise",
            meta : {
              permission: "Advise page",
            },
        },
        defaultComponentPath: "Pages/config/config_advise",
        navs: true,
    },
    // about
    // {
    //   params: {
    //     path: "/manage_page/Config_about",
    //     name: "manage_page/Config_about",
    //   },
    //   defaultComponentPath: "Pages/config/config_about",
    //   navs: true,
    // },
    // menu left
    {
      params: {
        path: "/manage_page/Menu_left",
        name: "manage_page/Menu_left",
        meta : {
          permission: "Menu left",
        },
      },
      defaultComponentPath: "Pages/config/menu/left",
      navs: true,
    },
    // config accessory
    {
      params: {
        path: "/manage_page/Config_accessory",
        name: "manage_page/Config_accessory",
        meta : {
          permission: "Accessory page",
        },
      },
      defaultComponentPath: "Pages/config/configAccessory/accessory",
      navs: true,
    },
    // config whybuy
    {
      params: {
        path: "/manage_page/Config_whybuy",
        name: "manage_page/Config_whybuy",
        meta : {
          permission: "Whybuy page",
        },
      },
      defaultComponentPath: "Pages/config/configWhyBuy/whybuy",
      navs: true,
    },
    // config showroom
    {
      params: {
        path: "/manage_page/Config_showroom",
        name: "manage_page/Config_showroom",
        meta : {
          permission: "Showroom page",
        },
      },
      defaultComponentPath: "Pages/config/configShowroom/showroom",
      navs: true,
    },
    // config footer
    {
      params: {
        path: "/manage_page/Config_footer",
        name: "manage_page/Config_footer",
        meta : {
          permission: "Footer",
        },
      },
      defaultComponentPath: "Pages/config/configFooter/footer",
      navs: true,
    },

  {
        params: {
            path: "/manage_page",
            name: "manage_page",
        },
        defaultComponentPath: "Pages/management_page",
        navs: true,
    },
    //category
    {
        params: {
            path: "/manage_productions/Manage_category",
            name: "manage_productions/Manage_category",
            meta : {
              permission: "List category product",
            },
        },
        defaultComponentPath: "Pages/management_production/category",
        navs: true,
    },
    {
        params: {
            path: "/manage_productions/category/add_category",
            name: "add_category",
        },
        defaultComponentPath: "Pages/category/addnew_category",
        navs: true,
    },
    {
        params: {
            path: "/manage_productions/category/edit_category/:id",
            name: "edit_category",
        },
        defaultComponentPath: "Pages/category/edit_category",
        navs: true,
    },
    {
        params: {
            path: "/manage_productions/category/detail_category/:id",
            name: "detail_category",
        },
        defaultComponentPath: "Pages/category/detail_category",
        navs: true,
    },

    //Tag
    {
        params: {
            path: "/manage_productions/tag",
            name: "manage_productions/Manage_tag",
            meta : {
              permission: "List tag",
            },
        },
        defaultComponentPath: "Pages/management_production/tag",
        navs: true,
    },
    {
        params: {
            path: "/manage_productions/tag/addnew_tag",
            name: "addnew_tag",
        },
        defaultComponentPath: "Pages/Tag/addnew_tag",
        navs: true,
    },
    {
        params: {
            path: "/manage_productions/tag/edit_tag/:id",
            name: "edit_category",
        },
        defaultComponentPath: "Pages/Tag/edit_tag",
        navs: true,
    },

    //attribute
    {
        params: {
            path: "/manage_productions/attribute",
            name: "manage_productions/Manage_attribute",
            meta : {
              permission: "List attribute",
            },
        },
        defaultComponentPath: "Pages/management_production/attribute",
        navs: true,
    },
    //accessory
    {
        params: {
            path: "/manage_productions/accessory",
            name: "manage_productions/Manage_accessories",
            meta : {
              permission: "List product",
            },
        },
        defaultComponentPath: "Pages/management_production/accessory",
        navs: true,
    },
    {
        params: {
            path: "/manage_productions/accessory/addnew_accessory",
            name: "addnew_accessory",
        },
        defaultComponentPath: "Pages/accessory/addnew_accessory",
        navs: true,
    },
    {
        params: {
            path: "/manage_productions/accessory/edit_accessory/:id",
            name: "edit_accessory",
        },
        defaultComponentPath: "Pages/accessory/edit_accessory",
        navs: true,
    },
    //production
  {
    params: {
      path: "/manage_productions/production",
      name: "manage_productions/Manage_production",
      meta : {
        permission: "List product",
      },
    },
    defaultComponentPath: "Pages/management_production/production",
    navs: true,
  },
  {
    params: {
      path: "/manage_productions/production/addnew_production",
      name: "addnew_production",
    },
    defaultComponentPath: "Pages/production/addnew_production",
    navs: true,
  },
  {
    params: {
      path: "/manage_productions/production/edit_product/:id",
      name: "edit_product",
    },
    defaultComponentPath: "Pages/production/edit_product",
    navs: true,
  },
  //showroom
  {
    params: {
      path: "/show_room",
      name: "show_room",
      meta : {
        permission: "List show_room",
      },
    },
    defaultComponentPath: "Pages/management_production/show_room",
    navs: true,
  },
  {
    params: {
      path: "/show_room/add_showroom",
      name: "add_show_room",
    },
    defaultComponentPath: "Pages/show_room/addnew_showroom",
    navs: true,
  },
  {
    params: {
      path: "/show_room/edit_showroom/:id",
      name: "edit_showroom",
    },
    defaultComponentPath: "Pages/show_room/edit_showroom",
    navs: true,
  },
  //warrantiesCenter
  {
    params: {
      path: "/warranties_center",
      name: "warranties_center",
      meta : {
        permission: "List warranties_center",
      },
    },
    defaultComponentPath: "Pages/management_production/warranties_center",
    navs: true,
  },
  {
    params: {
      path: "/warranties_center/add_warranties_center",
      name: "add_warranties_center",
    },
    defaultComponentPath: "Pages/warranties_center/addnew_warranties_center",
    navs: true,
  },
  {
    params: {
      path: "/warranties_center/edit_warranties_center/:id",
      name: "edit_warranties_center",
    },
    defaultComponentPath: "Pages/warranties_center/edit_warranties_center",
    navs: true,
  },
  //ssupport
  {
    params: {
      path: "/support",
      name: "support",
      meta : {
        permission: "List support",
      },
    },
    defaultComponentPath: "Pages/management_production/support",
    navs: true,
  },
//order
  {
    params: {
      path: "/management_order",
      name: "Manage_order",
      meta : {
        permission: "List order",
      },
    },
    defaultComponentPath: "Pages/Order/order_management",
    navs: true,
  },
  {
    params: {
      path: "/management_order/detail_order/:id",
      name: "detail_order",
    },
    defaultComponentPath: "Pages/Order/detail_order",
    navs: true,
  },
  //setting
  {
    params: {
      path: "/setting/cache",
      name: "setting",
    },
    defaultComponentPath: "Pages/setting",
    navs: true,
  },
    //customer
    {
        params: {
            path: "/management_customer",
            name: "manage_customer",
        },
        defaultComponentPath: "Pages/customer_management",
        navs: true,
    },
    // news
    {
        params: {
            path: "/manage_news/manage_new",
            name: "manage_news/Manage_new",
            meta : {
              permission: "List post",
            },
        },
        defaultComponentPath: "Pages/news_management",
        navs: true,
    },
    {
        params: {
            path: "/manage_news/manage_new/add_news",
            name: "add_news",
        },
        defaultComponentPath: "Pages/news/add_news",
        navs: true,
    },
    {
        params: {
            path: "/manage_news/manage_new/edit_news/:id",
            name: "edit_news",
        },
        defaultComponentPath: "Pages/news/edit_news",
        navs: true,
    },
    //category post
    {
        params: {
            path: "/manage_news/Manage_category",
            name: "manage_news/Manage_category_post",
            meta : {
              permission: "List category post",
            },
        },
        defaultComponentPath: "Pages/category_post/category",
        navs: true,
    },
    {
        params: {
            path: "/manage_news/Manage_category/add_category",
            name: "add_category_post",
        },
        defaultComponentPath: "Pages/category_post/addnew_category",
        navs: true,
    },
    {
        params: {
            path: "/manage_news/Manage_category/edit_category/:id",
            name: "edit_category_post",
        },
        defaultComponentPath: "Pages/category_post/edit_category",
        navs: true,
    },
    {
        params: {
            path: "/manage_news/Manage_category/detail_category/:id",
            name: "detail_category_post",
        },
        defaultComponentPath: "Pages/category_post/detail_category",
        navs: true,
    },
    {
        params: {
            path: "/management_warehouse",
            name: "manage_warehouse",
        },
        defaultComponentPath: "Pages/warehouse_management",
        navs: true,
    },
    {
        params: {
            name: "login",
            path: "/login",
            meta: { layout: "full" },
        },
        defaultComponentPath: "Pages/auth/login"
    },
    {
        params: {
            path: "*",
            name: "PageNotFound",
            meta: { layout: "full" },
        },
        defaultComponentPath: "Pages/Errors/Error404",
    },    
    {
        params: {
            path: "/forbidden",
            name: "Forbidden",
            meta: { layout: "full" },
        },
        defaultComponentPath: "Pages/Errors/Error403",
    },    
        // Promotion
        {
          params: {
            path: "/manage_promotion_gift/Manage_promotion",
            name: "manage_promotion_gift/Manage_promotion",
            meta : {
              permission: "List rule",
            },
          },
          defaultComponentPath: "Pages/promotion_gift/promotion/promotion",
          navs: true,
        },
            //Add Promotion
        {
          params: {
              path: "/manage_promotion_gift/Manage_promotion/add_promotion",
              name: "manage_promotion_gift/Manage_promotion/add_promotion",
          },
          defaultComponentPath: "Pages/promotion_gift/promotion/add_promotion",
          navs: true,
      },
        //Edit Promotion
        {
          params: {
            path: "/manage_promotion_gift/Manage_promotion/edit_promotion/:id",
            name: "manage_promotion_gift/Manage_promotion/edit_promotion",
          },
          defaultComponentPath: "Pages/promotion_gift/promotion/edit_promotion",
          navs: true,
        },

        // Gift
        {
          params: {
            path: "/manage_promotion_gift/Manage_gift",
            name: "manage_promotion_gift/Manage_gift",
            meta : {
              permission: "List promotion",
            },
          },
          defaultComponentPath: "Pages/promotion_gift/gift/gift",
          navs: true,
        },
          // add gift packages
        {
          params: {
            path: "/manage_promotion_gift/Manage_gift/add_gift_wrap",
            name: "manage_promotion_gift/Manage_gift/add_gift_wrap",
          },
          defaultComponentPath: "Pages/promotion_gift/gift/add_gift_wrap",
          navs: true,
        },
            // edit gift packages
        {
          params: {
            path: "/manage_promotion_gift/Manage_gift/edit_gift_wrap/:id",
            name: "manage_promotion_gift/Manage_gift/edit_gift_wrap",
          },
          defaultComponentPath: "Pages/promotion_gift/gift/edit_gift_wrap",
          navs: true,
        },
        // warranty

    {
        params: {
            path: "/manage_warranty/list_warranty",
            name: "manage_warranty/Active_warranty",
            meta : {
              permission: "List warranty",
            },
        },
        defaultComponentPath: "Pages/warranty/active_warranty/list_warranty",
        navs: true,
    },
    {
        params: {
            path: "/manage_warranty/edit_warranty/:id",
            name: "edit_warranty",
        },
        defaultComponentPath: "Pages/warranty/active_warranty/edit_warranty",
        navs: true,
    },
    {
        params: {
            path: "/manage_warranty/add_warranty",
            name: "add_warranty",
        },
        defaultComponentPath: "Pages/warranty/active_warranty/add_warranty",
        navs: true,
    },
    {
        params: {
            path: "/manage_warranty/list_error",
            name: "manage_warranty/Error_product",
            meta : {
              permission: "List error",
            },
        },
        defaultComponentPath: "Pages/warranty/error_product/list_error",
        navs: true,
    },
    {
        params: {
            path: "/manage_warranty/edit_error/:id",
            name: "edit_error",
        },
        defaultComponentPath: "Pages/warranty/error_product/edit_error",
        navs: true,
    },
    //comment
    {
        params: {
            path: "/comment",
            name: "comment",
            meta : {
              permission: "List comment",
            },
        },
        defaultComponentPath: "Pages/comment/list_comment",
        navs: true,
    },
    {
        params: {
            path: "/comment/detail_comment/:id",
            name: "detail_comment",
        },
        defaultComponentPath: "Pages/comment/detail_comment",
        navs: true,
    },
    {
        params: {
            path: "/comment/add_comment/:iFd",
            name: "detail_comment",
        },
        defaultComponentPath: "Pages/comment/add_comment",
        navs: true,
    },
    {
        params: {
            path: "/comment/detail_child_comment/:id",
            name: "detail_child_comment",
        },
        defaultComponentPath: "Pages/comment/detail_child_comment",
        navs: true,
    },
    //advise
    {
        params: {
            path: "/advise",
            name: "advise",
            meta : {
              permission: "List advise",
            },
        },
        defaultComponentPath: "Pages/advise/list_advise",
        navs: true,
    },
    {
        params: {
            path: "/advise/detail_advise/:id",
            name: "detail_advise",
        },
        defaultComponentPath: "Pages/advise/edit_advise",
        navs: true,
    },
    {
        params: {
            path: "/advise/add_advise",
            name: "add_advise",
        },
        defaultComponentPath: "Pages/advise/add_advise",
        navs: true,
    },
    //wards
    {
      params: {
          path: "/wards",
          name: "wards",
          meta : {
            permission: "List wards",
          },
      },
      defaultComponentPath: "Pages/regions/list_regions",
      navs: true,
    },
    //manage renew
    {
        params: {
            path: "/trade_in_sale",
            name: "renew",
            meta : {
              permission: "List trade_in_sale",
            },
        },
        defaultComponentPath: "Pages/renew/List_Renew",
        navs: true,
    },
    {
        params: {
            path: "/trade_in_sale/edit/:id",
            name: "Edit_Renew",
        },
        defaultComponentPath: "Pages/renew/Edit_Renew",
        navs: true,
    },
    //user
    {
      params: {
        path: "/setting/user",
        name: "setting_user",
      },
      defaultComponentPath: "Pages/role_user/role_user",
      // defaultComponentPath: "Pages/user/list_user",role_user
      navs: true,
    },
];
